var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.879,
    height: 34.396,
    viewBox: "0 0 36.879 34.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_thumb_up_3139185",
    "data-name": "noun_thumb up_3139185",
    transform: "translate(-798.5 -457.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(796 452.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M57.32,24.036a2.963,2.963,0,0,0,1.475-2.95,3.15,3.15,0,0,0-3.183-2.64h-9.7c.078-.194.194-.466.272-.7a19.591,19.591,0,0,0,1.669-6.988c0-3.144-2.213-5.047-3.727-5.163a1.683,1.683,0,0,0-1.786,1.592A25.011,25.011,0,0,1,40.2,13.206a3.012,3.012,0,0,1-.621.932A33.761,33.761,0,0,1,34.3,19.106c0,.078.039.194.039.272V37.973c0,.155-.039.311-.039.466a37,37,0,0,0,10.559,1.553h8.269a3.093,3.093,0,0,0,3.067-2.368,3.047,3.047,0,0,0-.97-2.911A3.031,3.031,0,0,0,57.553,31.8,2.9,2.9,0,0,0,56.5,29.549a2.987,2.987,0,0,0,.815-5.512Z",
    transform: "translate(-19.455)",
    fill: "#f68e3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M10.613,36.9H4.13A1.64,1.64,0,0,0,2.5,38.53V57.125a1.64,1.64,0,0,0,1.63,1.63h6.483a1.64,1.64,0,0,0,1.63-1.63V38.569A1.625,1.625,0,0,0,10.613,36.9ZM7.391,55.922A1.708,1.708,0,1,1,9.1,54.214,1.723,1.723,0,0,1,7.391,55.922Z",
    transform: "translate(0 -19.152)",
    fill: "#f68e3f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbIcon);
export default __webpack_public_path__ + "static/media/thumb-icon.3605a82b22b17db4c4151f374cc55c22.svg";
export { ForwardRef as ReactComponent };